<template>
  <label class="flex flex-row gap-2 items-center">
    <CheckboxRoot
      v-model="checked"
      class="hover:bg-primary/85 bg-primary flex size-4 appearance-none items-center justify-center rounded outline-none transition-all duration-75"
    >
      <CheckboxIndicator
        class="bg-primary h-full w-full rounded flex items-center justify-center"
      >
        <Icon icon="mdi:check" class="size-3 text-white" />
      </CheckboxIndicator>
    </CheckboxRoot>

    <span class="select-none text-[#B7B7B7] text-sm">{{
      $t("channel.translation.toggle.dontShow")
    }}</span>
  </label>
</template>

<script setup lang="ts">
import { useTranslationStore } from "@/stores/translation.store";
import { Icon } from "@iconify/vue";
import { CheckboxIndicator, CheckboxRoot } from "reka-ui";
import { computed } from "vue";

const translationStore = useTranslationStore();
const checked = computed({
  get: () => !translationStore.enableMobileAutoTranslateConfirmation,
  set: (value: boolean) => {
    translationStore.enableMobileAutoTranslateConfirmation = !value;
  },
});
</script>
